<template>
  <div>
    <div class="post-thumbs-listing active-edit-list listing-rowed items-md-2-per-row items-lg-3-per-row mt-4" v-if="contents.length > 0">
      <ul class="list-wrap">
        <li
          class="list-item"
          v-for="content in contents"
          :key="content.entity.id"
        >
          <PostThumbCard
            :post="content.entity"
            v-if="content.type === 'post'"
            :isSelectAvailable="user && list.user.id === user.id"
            @post-selected="postSelected"
          />
          <BookThumbCard
            :book="content.entity"
            v-if="content.type === 'book'"
            :isSelectAvailable="user && list.user.id === user.id"
            @book-selected="bookSelected"
          />
        </li>
      </ul>
    </div>
    <div class="text-center" v-else>
      <p
        class="text-center"
      >
        Essa lista ainda não possui publicações adicionadas!
      </p>
    </div>

    <ListMultipleDelete
      v-if="selected.length > 0"
      :contents="selected"
      :list="list"
      @items-destroyed="destroyed"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex'

import BookThumbCard from '@/components/books/BookThumbCard'
import ListMultipleDelete from '@/components/lists/ListMultipleDelete'
import PostThumbCard from '@/components/post/PostThumbCard'

export default {
  name: 'ListContentList',
  props: ['list', 'contents'],
  components: {
    BookThumbCard,
    ListMultipleDelete,
    PostThumbCard
  },
  data () {
    return {
      selected: []
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    postSelected (post) {
      this.$emit('post-selected', post)
      this.handleSelectItem(post, 'post')
    },
    bookSelected (book) {
      this.$emit('book-selected', book)
      this.handleSelectItem(book, 'book')
    },
    handleSelectItem (item, type) {
      // Add to array
      if (item.action) {
        item.card.type = type
        this.selected = [...this.selected, item.card]
      } else {
        // Remove from array
        const index = this.selected.findIndex(c => c.id === item.id)
        this.selected.splice(index, 1)
      }
    },
    destroyed (items) {
      items.forEach(item => {
        const index = this.contents.findIndex(c => c.entity.id === item.id)
        this.contents.splice(index, 1)
      })
      this.selected = []
      this.$emit('items-destroyed', items)
    }
  }
}
</script>
